/**
* liuyaoao  2018/2/8.
* 资源监测-左侧资源树
 */
import React,{Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {SearchOutlined ,PlusSquareOutlined ,MinusSquareOutlined ,FolderOpenTwoTone ,FolderTwoTone ,HddTwoTone ,DragOutlined} from '@ant-design/icons'
import { Tree, Input, Icon, Popover,Modal, notification,Dropdown, Menu, Spin ,Tag } from 'antd';
const TreeNode = Tree.TreeNode;
const Search = Input.Search;
const confirm = Modal.confirm;
import confirmPrompt from '@common/confirmPrompt';
import Store from '../../app/script/store';
import { moveDevices } from '@app/server/ofbiz/equipmentGroup';
import Utils from '../../app/script/utils';
import IconFont from '../../app/components/common/iconfont';
import StatusIcon from '../../app/components/common/statusIcon';
import * as homeActions from '../../app/actions/home_action';
import * as deviceMonitorTreeActions from '../../app/actions/deviceMonitorTree_action';
import * as deviceMonitorActions from '../../app/actions/deviceMonitor_action';
import * as equipmentActions from '../../app/actions/equipment_action';
import * as settingActions from '../../app/actions/setting_action';
import * as threeDPerspectiveDiagramActions from '../../app/actions/threeDPerspectiveDiagram_action';
import MoveEquipment from './components/moveEquipment';
let treenodeIndex=0, initialSelectedGroupId="", initialSelectedGroupName="";
let refreshTime;
let cyPosition={};
let filteTypes = [
    {type:"0", name:"全部"},
    {type:"1", name:"摄像机"},
    {type:"2", name:"DVR"},
    {type:"3", name:"NVR"},
    {type:"4", name:"编码器"},
    {type:"5", name:"IPSAN"}
];
let mouseDownClientX = -1, mouseDownClientY = -1;

class MonitorTreeComp extends Component{
  MoveEquipmentRef=React.createRef()
  state = {
    backupGroupNode: {name:'IT资源树', id:'se'},
    preNode: {name:'IT资源树', id:'se'},
    windowHeight:570,
    headerHeight:38,
    bMountMonitorTree:true,
    filteType: filteTypes[0],
    foldRootTree:false,  //是否折叠展开根节点树。
    showQuickSearch:false,
    showTypeFilter:false,
    expandedKeys: [],
    searchValue: '',
    autoExpandParent: true,
    selectedKeys: [],
    loadingTree: false,
    filterTreeStore: [],

    paneArr: []
  }
  componentWillMount(){
  }
  componentDidMount(){
    this.props.deviceMonitorActions.setMonitorTreeComp(this);
    $("body").bind("mousedown", this.onBodyMouseDownRight);
    $("body").bind("mousemove", this.onBodyMouseMove);
    $("body").bind("mouseup", this.onBodyMouseUp);
    $("body").bind("mouseout", this.onBodyMouseOut);
    sessionStorage.removeItem('__paneArr__')
  }
  componentWillUnmount () {
    clearInterval(refreshTime);
    this.props.equipmentActions.saveResourcesData(null);
    this.props.deviceMonitorActions.setMonitorView(0);
    $("body").unbind("mousedown", this.onBodyMouseDownRight);
    $("body").unbind("mousemove", this.onBodyMouseMove);
    $("body").unbind("mouseup", this.onBodyMouseUp);
    $("body").unbind("mouseout", this.onBodyMouseOut);
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.deviceMonitorTreeData != this.props.deviceMonitorTreeData){
      let { rootArr, deviceMonitorTreeMap } = Utils.formatTreeData(nextProps.deviceMonitorTreeData);
      console.log('[monitorTreeComp] formatTreeData rootArr:', rootArr, 'map:', deviceMonitorTreeMap);
      this.props.deviceMonitorTreeActions.setDeviceMonitorTreeMap(deviceMonitorTreeMap);
      this.props.deviceMonitorTreeActions.setTreeStore(rootArr);
    }
    if (nextProps.selectedNode&&nextProps.selectedNode!=this.props.selectedNode) {
      var expandedKeys_add = [];
      let loop = data => {
        let pid = '';
        if (data.pid&&data.pid != '') {
          pid = data.pid;
          if (this.state.expandedKeys.indexOf(pid) == -1) {
            expandedKeys_add.push(pid);
          }
          if (nextProps.deviceMonitorTreeMap[pid]) {
            loop(nextProps.deviceMonitorTreeMap[pid])
          }
        }
      };
      loop(nextProps.selectedNode);
      let expandedKeys = [...this.state.expandedKeys, ...expandedKeys_add];
      this.setState({
        expandedKeys,
        selectedKeys: [nextProps.selectedNode.id]
      });
      //IT资源树跟随滚动
      setTimeout(()=>{
        var treeStore = this.state.showQuickSearch && this.state.searchValue ? this.state.filterTreeStore : this.props.treeStore;
        var scrollHeight = 0;
        let loop2 = data => data.map((item) => {
          if (item.id != this.state.selectedKeys[0]) {
            if (item.children&&item.children.length>0&&this.state.expandedKeys.indexOf(item.id)>-1) {
              scrollHeight += 28;
              loop2(item.children);
              scrollHeight += 4;
            }
            else {
              scrollHeight += 32;
            }
          }
          else {
            scrollHeight = scrollHeight!=0 ? scrollHeight+3 : scrollHeight;
            if (scrollHeight < $('#customTreeListContainer').scrollTop() || (scrollHeight > $('#customTreeListContainer').scrollTop() && scrollHeight-$('#customTreeListContainer').scrollTop() > $('#customTreeListContainer').height()-32)) {
              $('#customTreeListContainer').scrollTop(scrollHeight);
            }
          }
        });
        loop2(treeStore);
      });
    }
  }

  _addExpandedKeys = (key) => {
    if (key != '' && this.state.expandedKeys.indexOf(key) == -1) {
      let expandedKeys = [...this.state.expandedKeys, key];
      this.setState({expandedKeys});
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
      const { noRefreshMonitorViewFlag } = nextProps;
      if (nextProps.deviceMonitorTreeData !== this.props.deviceMonitorTreeData) {
        // console.log("deviceMonitorTreeData---:",nextProps.deviceMonitorTreeData);
          if(nextState.bMountMonitorTree) {
            if(!noRefreshMonitorViewFlag) {
              this.setState({bMountMonitorTree: false});
              this.handleMonitorTreeDidMount(nextProps);
              if(nextProps.navigateFromCreateMonitorViewFlag) {
                //TODO
              }
            } else {
              this.props.deviceMonitorActions.setNoRefreshMonitorViewFlag(false);
            }
          }
      }
      return true;
  }

  handleMonitorTreeDidMount(props){
    const { deviceMonitorTreeData, pieChartMonitorType} = props;
    //默认展示根节点下的所有子组的信息。
    this.updateSubGroupView({name:'IT资源树', id:'se'}, true); //右侧展示总根节点。
    refreshTime = setInterval(this.handleOnClickRefreshMonitorTree, 300000, false);       //每隔5分钟刷新1次监测树
  }
  //隐藏菜单
  onBodyMouseDownRight = (event)=>{
      var rMenu = $("#rMenu3");
      if (!(event.target.id == "rMenu3" || $(event.target).parents("#rMenu3").length>0)) {
          rMenu.css({"visibility" : "hidden"});
      }
      var rMenu4 = $("#rMenu4");
      if (!(event.target.id == "rMenu4" || $(event.target).parents("#rMenu4").length>0)) {
          rMenu4.css({"visibility" : "hidden"});
      }
      var rMenu5 = $("#rMenu5");
      if (!(event.target.id == "rMenu5" || $(event.target).parents("#rMenu5").length>0)) {
          rMenu5.css({"visibility" : "hidden"});
      }
  }
  //点击了树的某一项的事件。
  onTreeItemClick = (selectedKeys, info)=>{
    let item = this.props.deviceMonitorTreeMap[info.node.props.eventKey];
    let newTreeNode = this.cloneNodeWithoutChildren(item);
    this.props.equipmentActions.setOnTreeNodeClick(true);
    this.props.equipmentActions.setSelectedNode(newTreeNode);
    this.props.equipmentActions.setBackupTreeNode(newTreeNode);
    this.props.equipmentActions.setSelectedClickNode(newTreeNode);
    this.onClickMonitorTreeNode(newTreeNode);
  }

  //克隆一个节点的数据，除了children项。
  cloneNodeWithoutChildren = (nodeData)=>{
    let newData = {};
    for(let key in nodeData){
      if(key !='children'){
        newData[key] = nodeData[key];
      }else{
        newData['children'] = nodeData['children'].length;
      }
    }
    return newData;
  }

  //---------树节点右键事件  弹出右键菜单----------
  onTreeItemRightClick = (e)=>{
    // console.log(e.node.props);
      let treeNode = this.props.deviceMonitorTreeMap[e.node.props.eventKey];
      this.props.equipmentActions.setSelectedNode(treeNode);
      let width = e.event.clientX; //右键菜单弹出X轴位置
      let height = e.event.clientY; //右键菜单弹出Y轴位置
      let screenHeight = document.body.clientHeight;
      let tStatu = treeNode.status;
      if(tStatu == "good"){
        $("#monitorTree2Startli").hide();
        $("#monitorTree2Disableli").show();
        $("#rightMenuStartEquipmentLi").hide();
        $("#rightMenuDisableEquipmentLi").show();
      }else if(tStatu == "disabled"){
        $("#monitorTree2Startli").show();
        $("#monitorTree2Disableli").hide();
        $("#rightMenuStartEquipmentLi").show();
        $("#rightMenuDisableEquipmentLi").hide();
      }
      var type = treeNode.type;
      if(type == "root"){
        this.setState({preNode: {name:'IT资源树', id:'se'}});
      }else if(type == "group"){
        $("#rMenu3 ul").show();
        let menuHeight = $("#rMenu3").height() + 2;
        if (screenHeight-height < menuHeight) {
          height = height - menuHeight;
        }
        $("#rMenu3").css({"top":height+"px", "left":width+"px", "visibility":"visible","z-index":"999"});
      }else if(type.substr(0,9).toLowerCase() == "equipment"){
        // this.props.equipmentActions.getResourcesPropertyDataFromID(treeNode.RecId);//获取当前选择的资源属性数据
        // this.props.equipmentActions.getEquipment(treeNode.RecId);
        // this.props.equipmentActions.setSelectedResourceByRightClickTree(treeNode);
        $("#rMenu4 ul").show();
        let menuHeight = $("#rMenu4").height() + 2;
        if (screenHeight-height < menuHeight) {
          height = height - menuHeight;
        }
        $("#rMenu4").css({"top":height+"px", "left":width+"px", "visibility":"visible","z-index":"999"});
      } else if(type == "monitor"){
        $("#rMenu5 ul").show();
        let menuHeight = $("#rMenu5").height() + 2;
        if (screenHeight-height < menuHeight) {
          height = height - menuHeight;
        }
        $("#rMenu5").css({"top":height+"px", "left":width+"px", "visibility":"visible","z-index":"999"});
      }
  }

  //organize 过滤掉 organize
  getNewTreeDatas(datas){
    var newTreeD = [];
    let filterTypes = ['organize','code','nvr','dvr','vedio','ipsan','other'];
    for(var i= 0;i < datas.length;i++){
      if(filterTypes.indexOf(datas[i].type)==-1){
        newTreeD.push(datas[i]);
      }
    }
    return newTreeD;
  }

  onClickMonitorTreeNode(treeNode) {
      // console.log(treeNode);
      const { deviceMonitorTreeData, pieChartMonitorType } = this.props;
      const nodeTypeMap = {'vedio':'1', 'dvr':'2', 'nvr':'3', 'code':'4', 'ipsan':'5'};
      if(nodeTypeMap[treeNode.type]) {
          let filter = [{key:"SELECTGROUP",value:treeNode.pid}, {key:"GROUPID",value:treeNode.RecId}, {key:"NAME",value:treeNode.name.substring(0, treeNode.name.indexOf("("))}, {key:"TYPE",value:nodeTypeMap[treeNode.type]}];
          var tmpFilter = filter.slice(0);
          if(document.getElementById("fixed-monitorTable-pagination") != null) {
              document.getElementById("fixed-monitorTable-pagination").style.display = "block";
              $('#monitorTable').bootstrapTable('refreshOptions', {
                  pagination: false
              });
          }
          var monitorName, searchAreaData, settingSearchAreaData;
          for(var i = 0; i < deviceMonitorTreeData.length; i++) {
              if(deviceMonitorTreeData[i].id == treeNode.pid) {
                  monitorName = deviceMonitorTreeData[i].name.substring(0, deviceMonitorTreeData[i].name.indexOf("(")) + "-" + treeNode.name;
                  searchAreaData = deviceMonitorTreeData[i];
                  settingSearchAreaData = deviceMonitorTreeData[i];
                  break;
              }
          }
          this.props.deviceMonitorActions.setbClickTreeNode(true);
          this.props.deviceMonitorActions.setGetTearmListDataType(0);
          this.props.deviceMonitorActions.setMonitorGroupId(treeNode.RecId);
          this.props.deviceMonitorActions.setMonitorView(2);
          this.props.deviceMonitorActions.setMonitorName(monitorName);
          this.props.deviceMonitorActions.setSearchAreaData(searchAreaData);
          this.props.deviceMonitorActions.setSettingSearchAreaData(settingSearchAreaData);
          this.props.deviceMonitorActions.setMonitorTableCurrentPage(1);
          this.props.deviceMonitorActions.setMonitorTableNumPerPage(20);
          this.props.deviceMonitorActions.setMonitorTableFilter(tmpFilter);
          this.props.deviceMonitorActions.setMonitorFilterStatus("all");
          filter.push({key:"FROM", value:0});
          filter.push({key:"TO", value:20});
          setTimeout( ()=>{
            this.props.deviceMonitorActions.getGroupListDataByClickTree(filter);
          }, 1000);
        // sessionStorage.removeItem('__paneArr__');
      }else if(treeNode.type=="organize" || treeNode.type=="other") {
        var filter = [{key:"GROUPID",value:treeNode.RecId},{key:"TYPE",value:pieChartMonitorType}];
        this.props.deviceMonitorActions.setGetTearmListDataType(0);
        this.props.deviceMonitorActions.setMonitorGroupId(treeNode.RecId);
        this.props.deviceMonitorActions.setMonitorView(1);
        this.props.deviceMonitorActions.setMonitorName(treeNode.name);
        this.props.deviceMonitorActions.getTearmListData(filter);
        // sessionStorage.removeItem('__paneArr__');
      }else if(treeNode.type=="group") {
        this.props.deviceMonitorActions.setMonitorView(3);
        // sessionStorage.removeItem('__paneArr__');
      }else if(treeNode.type.substr(0,9).toLowerCase()=="equipment") {
        let ids = treeNode.EquipmentMonitor.map((item) => { return item.RecId; });
        if(ids.length > 0) {
          this.props.deviceMonitorActions.getThresholdList(ids, (data)=>{
            this.props.equipmentActions.setBackupResource(treeNode);
            this.props.equipmentActions.setbClickTreeNode(true);
            this.props.deviceMonitorActions.setMonitorView(4);
          });
        } else {
          this.props.equipmentActions.setBackupResource(treeNode);
          this.props.equipmentActions.setbClickTreeNode(true);
          this.props.deviceMonitorActions.setMonitorView(4);
        }
        // sessionStorage.removeItem('__paneArr__');
      } else if(treeNode.type=="monitor") {
        // console.log(treeNode)
        // let panes = JSON.parse(sessionStorage.getItem('__paneArr__'));
        // let paneArr = panes ? panes : [];
        // const arr = []
        // if (paneArr.length <= 0) {
        //   let obj = {
        //     paneKey: treeNode.id,
        //     title: treeNode.name,
        //     selectedClickNode: treeNode
        //   }
        //   arr.push(obj);
        //   paneArr = arr;
        //   sessionStorage.setItem('__paneArr__', JSON.stringify(paneArr))
        // } else {
        //   for (let i = 0; i < paneArr.length; i++) {
        //     if (paneArr[i].paneKey !== treeNode.id) {
        //       let obj = {
        //         paneKey: treeNode.id,
        //         title: treeNode.name,
        //         selectedClickNode: treeNode
        //       }
        //       arr.push(obj)
        //       paneArr = paneArr.concat(arr);
        //       sessionStorage.setItem('__paneArr__', JSON.stringify(paneArr))
        //     }
        //   }
        // }

        this.props.deviceMonitorActions.getThresholdList([treeNode.id], (data)=>{
          // this.props.equipmentActions.getMonitorsExtraPropertyDataFromID({monitorId: treeNode.id, monitorType: treeNode.MonitorType});
          const selectedResource = this.props.deviceMonitorTreeMap[treeNode.EquipmentId];
          this.props.equipmentActions.setSelectedResource(selectedResource);
          // this.props.equipmentActions.setSelectedMonitor(treeNode);
          this.props.deviceMonitorActions.setMonitorView(5);
        });
      }
  }

  handleCreateResourceModal = (isEdit)=>{ //添加 或者 编辑 资源弹窗。
    //设置资源属性编辑状态，true 是编辑资源 , false 是增加资源
    var rMenu = $("#rMenu3");
    if (isEdit) {
      rMenu = $("#rMenu4");
    }
    if (rMenu) rMenu.css({"visibility": "hidden"});
    // $('#createResourceModal').modal('show');
    if (isEdit) {
      let treeNode = this.props.selectedNode;
      let ids = treeNode.EquipmentMonitor.map((item) => { return item.RecId; });
      if(ids.length > 0) {
        this.props.deviceMonitorActions.getThresholdList(ids, (data)=>{
          this.props.equipmentActions.setBackupResource(treeNode);
          this.props.equipmentActions.setbClickTreeNode(true);
          this.props.deviceMonitorActions.setMonitorView(4);
          this.props.equipmentActions.setResourceViewActiveTab('3');
        });
      } else {
        this.props.equipmentActions.setBackupResource(treeNode);
        this.props.equipmentActions.setbClickTreeNode(true);
        this.props.deviceMonitorActions.setMonitorView(4);
        this.props.equipmentActions.setResourceViewActiveTab('3');
      }
    } else {
      //产品授权点数验证
      this.productLicenseAuth(()=>{
        this.props.deviceMonitorTreeActions.openResourcePanel('add_resource');
      });
    }
  }
  //打开添加或编辑模态窗口
  onClickAddNewSubGroup = (isEditGroup, onTableAddGroup)=>{
    var rMenu = $("#rMenu3");
    if (rMenu) rMenu.css({"visibility": "hidden"});
    if(isEditGroup){
      // this.setState({addOrEditGroupTitle: '编辑分组', addOrEditGroupVisible: true, isEditGroup, onTableAddGroup});
      this.props.deviceMonitorTreeActions.openResourcePanel('edit_group');
      this.props.deviceMonitorActions.getEccGroupById(this.props.selectedNode.id, (re) => {
        // this.opGroupNameForm.props.form.setFieldsValue({GroupName: re.GroupName, Description: re.Description});
      });
    } else {
      // this.setState({addOrEditGroupTitle: '添加分组', addOrEditGroupVisible: true, isEditGroup, onTableAddGroup});
      this.props.deviceMonitorTreeActions.openResourcePanel('add_group');
      // setTimeout(()=>{
      //   this.opGroupNameForm.props.form.setFieldsValue({GroupName: '', Description: ''});
      // }, 100);
    }
  }
  _onClickSortAll = ()=>{ //全部排序

  }
  _handleOnClickShrinkAll = ()=>{ //折叠所有
    this.setState({
      expandedKeys: [],
      searchValue: '',
      autoExpandParent: false,
    });
  }
  _handleOnClickExpandAll = ()=>{ //展开所有
    let expandedKeys = [];
    let loop = data => data.map((item) => {
      if (item.children&&item.children.length>0) {
        expandedKeys.push(item.id);
        loop(item.children);
      }
    });
    loop(this.props.treeStore);
    this.setState({
      expandedKeys,
      searchValue: '',
      autoExpandParent: true,
    });
  }

  onExpand = (expandedKeys) => {
    this.setState({
      expandedKeys,
      autoExpandParent: false,
    });
  }


  onDrop =(info)=>{
    console.log(info);
    const {dragNode,node}=info;
    if(dragNode.type==='equipment'&&node.type==='group'){
      confirmPrompt('提示！',
      <div><span>确定把</span>
       <Tag icon={<HddTwoTone twoToneColor={'#00cc00'} />} color="success">{dragNode.name}</Tag>
        <span>移动到</span> <Tag icon={<FolderOpenTwoTone twoToneColor={'red'} />} color="warning">{node.name}</Tag>
        ？
      </div>,
      () => {
        console.log(13456466)
        this.sendMoveEquipments(node.key,dragNode.key)
      },
      ()=>{
        console.log('取消')
      }
      )
    }
  }

   sendMoveEquipments = (groupid, machineid) => {
    moveDevices(groupid, machineid).then((res) => {
      console.log(res)
      notification.success({
        message: '系统提示',
        description: '移动成功',
      });
      this.props.deviceMonitorTreeActions.getDeviceMonitorTreeData(null, (result) => {
        console.log(result)
        // if (result) {
        //   Utils.showMessageDialog("提示", "IT资源树刷新成功！");
        // } else {
        //   Utils.showMessageDialog("提示", "IT资源树刷新失败！", 'error');
        // }
      });
    }).catch((error) => {
      console.log(error)
    })
  }

  //搜索框输入事件，进行节点搜索（结果高亮处理）
  searchTreeNodeByInputValue = (e) => {
    const value = e.target.value.toLowerCase();
    let expandedKeys = [], filterTreeIds = [];
    // let regex = eval(`/${value}/gi`);regex.test(item.name);
    let loop = data => data.map((item) => {
      const flag = item.name.toLowerCase().indexOf(value) > -1 || (item.ServerAddress && item.ServerAddress.toLowerCase().indexOf(value) > -1);
      if (flag) {
        if (expandedKeys.indexOf(item.pid) == -1) {
          expandedKeys.push(item.pid);
        }

        if (filterTreeIds.indexOf(item.id) == -1) {
          filterTreeIds.push(item.id);
          this.findParentNode(item.id, filterTreeIds);
        }
      }
      if (item.children) {
        loop(item.children);
      }
    });
    if (value&&value.trim()!='') {
      loop(this.props.treeStore);
      expandedKeys.filter((item, i, self) => item && self.indexOf(item) === i);
    }

    // 处理过滤后重构资源树数据
    let loop2 = data => {
      for (var i = 0; i < data.length; i++) {
        const item = data[i];
        if (filterTreeIds.indexOf(item.id) == -1) {
          data.splice(i, 1);
          i = i - 1;
        }
        if (item.children && item.children.length) {
          loop2(item.children);
        }
      }
    }
    let _store = [];
    if (value) {
      _store = $.extend(true, [], this.props.treeStore);
      loop2(_store);
    }

    this.setState({
      expandedKeys,
      searchValue: value,
      autoExpandParent: true,
      filterTreeStore: _store
    });
  }

  findParentNode = (id, filterTreeIds) => {
    const { deviceMonitorTreeMap } = this.props;
    const _pid = deviceMonitorTreeMap[id].pid;
    if (_pid && filterTreeIds.indexOf(_pid) == -1) {
      filterTreeIds.push(_pid);
      this.findParentNode(_pid, filterTreeIds);
    }
  }

  onClickRefreshTree = () => {
    this.onTreeRootClick({name:'IT资源树', id:'se', pid:''});
    const auditData = {
      type: 'refresh_tree',
      OperationBo: 'IT资源树',
    }
    this.setState({loadingTree: true});
    this.props.deviceMonitorTreeActions.getDeviceMonitorTreeData(null, (result)=>{
      this.setState({loadingTree: false});
      if (result) {
        Utils.showMessageDialog("提示", "IT资源树刷新成功！");
      } else {
        Utils.showMessageDialog("提示", "IT资源树刷新失败！", 'error');
      }
      this.props.equipmentActions.receiveCreateOperationAudit({ ...auditData, OperationResults: result });
    });
  }

  onTreeRootClick = (treeRoot) => {
    this.setState({selectedKeys: []});
    this.updateSubGroupView(treeRoot, true);
  }

  onRefreshTree = (node)=>{ // 更新树 和右侧视图。
    let curNode = node || this.state.preNode;
    this.handleOnClickRefreshMonitorTree(()=>{
      this.updateSubGroupView(curNode);
    });
  }

  handleOnClickRefreshMonitorTree = (callback)=>{
    let evt = null;
    if(this.state.filteType.type == "0") {
      let params = evt ? [{key:"ISREALTIME", value: "1"}] : null;
      this.props.deviceMonitorTreeActions.getDeviceMonitorTreeData(params,callback);
    }else {
        this.props.deviceMonitorTreeActions.getDeviceMonitorTreeDataByType([{key:"TYPE", value: this.state.filteType.name}],callback);
    }
  }

  //更新右侧视图
  updateSubGroupView = (nodeData, isRoot)=>{
    if (!isRoot && (this.props.monitorView == 4 || this.props.monitorView == 5)) {
      this.checkRefreshMonitorView();
    } else {
      this.props.equipmentActions.setOnTreeNodeClick(true);
      let { deviceMonitorTreeMap } = this.props;
      let node = nodeData;
      if (nodeData.RecId) {
        node = Object.assign(deviceMonitorTreeMap[nodeData.RecId], {});
      }
      this.props.equipmentActions.setSelectedNode(node);
      this.props.equipmentActions.setSelectedClickNode(node);
      this.props.equipmentActions.setBackupTreeNode(node);
      if (nodeData.type == 'equipment') {
        // this.props.equipmentActions.setBackupResource(nodeData);
        this.props.deviceMonitorActions.setMonitorView(4);
      } else if (nodeData.type == 'monitor') {
        this.props.deviceMonitorActions.setMonitorView(5);
      } else {
        this.props.deviceMonitorActions.setMonitorView(3);
      }
    }
  }

  getTreeNodeIcon = (node, expanded) => {
    var _status = node.Status || node.EquipmentStatus || node.MonitorStatus;
    let _color = '';
    if (_status == 'good') {
      _color = '#00cc00';
    } else if (_status == 'warning') {
      _color = 'orange';
    } else if (_status == 'error') {
      _color = 'red';
    } else if (_status == 'disabled') {
      _color = '#aaa';
    }
    // 节点类型判断：formatTreeData 把 GROUP 设为 type='group'，EQUIPMENT 设为 'equipment'
    if (node.type == 'group') {
      // 分组=文件夹图标，颜色由后端返回的 status 决定
      var groupColor = _color || '#1677ff';
      return  expanded ? <FolderTwoTone   twoToneColor={groupColor} />
      :<FolderOpenTwoTone   twoToneColor={groupColor} />
      // return <Icon type={expanded ? 'folder-open' : 'folder'} theme="twoTone" twoToneColor={_color} />;
    } else if (node.type == 'monitor') {
      return <StatusIcon status={_status} record={node} />;
    }
    // 设备=硬盘图标，无状态时默认蓝色
    var equipColor = _color || '#1677ff';
    return <HddTwoTone twoToneColor={equipColor}  onMouseDown={(e)=>this.onMouseDownTreeNode(e, node)}/>;
  }

  contextMenuVisibleChange = (visible) => {
    if (visible) {
      this.props.equipmentActions.setSelectedNode({name:'IT资源树', id:'se'});
    }
  }

  onClickSortGroup = (key, isRoot) => {
    let selectedNode = this.props.selectedNode || {};
    let pid = selectedNode.id || ''; //这个是新增子组的父节点id.
    if (key) {
      this.props.deviceMonitorTreeActions.openResourcePanel('sort_group');
      if (isRoot) {
        this.props.deviceMonitorActions.setChildrenGroup(this.props.treeStore);
      } else {
        this.props.deviceMonitorActions.getChildrenGroups(pid);
        this.props.deviceMonitorActions.getChildrenEquip(pid);
      }
      var rMenu = $("#rMenu3");
      if (rMenu) rMenu.css({"visibility": "hidden"});
    } else {
      this.props.deviceMonitorTreeActions.openResourcePanel('sort_resource');
      this.props.deviceMonitorActions.setChildrenMonitor(selectedNode.EquipmentMonitor);
      var rMenu = $("#rMenu4");
      if (rMenu) rMenu.css({"visibility": "hidden"});
    }
  }

  getNodeStatus = (node) => {
    if (!node) {
      return '';
    }
    if (node.type == 'group') {
      return node.Status;
    } else if (node.type == 'equipment') {
      return node.EquipmentStatus;
    } else if (node.type == 'monitor') {
      return node.MonitorStatus;
    }
  }

  getStatusCanvas = (status) => {
    let colorRGB = '';
    if (status == 'good') {
      colorRGB = '0,204,0';
    } else if (status == 'warning') {
      colorRGB = '255,165,0';
    } else if (status == 'error') {
      colorRGB = '255,0,0';
    } else if (status == 'disabled') {
      colorRGB = '170,170,170';
    }

    var canvas = document.createElement('canvas');
    canvas.width = 64;
    canvas.height = 64;
    var ctx = canvas.getContext('2d');
    var grd=ctx.createRadialGradient(32,32,20,32,32,32);
    grd.addColorStop(0, 'rgba('+colorRGB+',1)');
    grd.addColorStop(1, 'rgba('+colorRGB+',0)');
    ctx.fillStyle=grd;
    ctx.fillRect(0,0,64,64);
    return canvas;
  }

  onMouseDownTreeNode = (e, node) => {
    let { networkNodes, resourceViewType, b2DMode } = this.props;
    if (resourceViewType == '立体拓扑' && b2DMode && Utils.hasPermission('topoNode', 'add') && e.button == 0) {
      var flag = false;
      for (var i = 0; i < networkNodes.length; i++) {
        if (networkNodes[i].NodeRelationMonitor == node.id) {
          flag = true;
          break;
        }
      }
      if (node.type == 'equipment' && !node.NodeType && !flag) {
        this.props.equipmentActions.setDraggedNode(node);
        this.props.threeDPerspectiveDiagramActions.setAddedDraggedNodeIn3D(false);
        mouseDownClientX = e.clientX;
        mouseDownClientY = e.clientY;
      }
    }
    else {
      this.props.equipmentActions.setDraggedNode(null);
    }
  }

  onBodyMouseMove = (e)=> {
    let { draggedNode, bAddedDraggedNodeIn3D } = this.props;
    if (draggedNode != null && !document.getElementById('draggedNodeDiv') && (mouseDownClientX != e.clientX || mouseDownClientY != e.clientY) && !bAddedDraggedNodeIn3D) {
      var draggedNodeDiv = document.createElement('div');
      draggedNodeDiv.id = 'draggedNodeDiv';
      $(draggedNodeDiv).css({'position':'absolute', 'top':e.clientY-32+'px', 'left':e.clientX-32+'px', 'z-index':'999', 'opacity':'0.8', 'pointer-events':'none'});
      var statusCanvas = this.getStatusCanvas(draggedNode.EquipmentStatus);
      $(statusCanvas).css({'position':'absolute'});
      draggedNodeDiv.appendChild(statusCanvas);
      var draggedNodeImg = document.createElement('img');
      $(draggedNodeImg).css({'position':'absolute', 'width':'64px', 'height':'64px'});
      let mapUrl = Store.get('mapUrl');
      draggedNodeImg.src = mapUrl + (draggedNode.Image =='' ? '/resource/20181227/Default.png' : draggedNode.Image);
      draggedNodeImg.draggable = false;
      draggedNodeDiv.appendChild(draggedNodeImg);
      document.body.appendChild(draggedNodeDiv);
    }
    $('#draggedNodeDiv').css({'top':e.clientY-32+'px', 'left':e.clientX-32+'px'});
  }

  onBodyMouseUp = (e)=> {
    if (this.props.draggedNode != null) {
      if (document.getElementById('draggedNodeDiv')) {
        document.body.removeChild(document.getElementById('draggedNodeDiv'));
      }
      this.props.equipmentActions.setDraggedNode(null);
    }
  }

  onBodyMouseOut = (e)=> {
    if (this.props.draggedNode != null && (e.clientX < 0 || e.clientX > window.innerWidth || e.clientY < 0 || e.clientY > window.innerHeight)) {
      if (document.getElementById('draggedNodeDiv')) {
        document.body.removeChild(document.getElementById('draggedNodeDiv'));
      }
      this.props.equipmentActions.setDraggedNode(null);
    }
  }

  render (){
    let {selectedNodeId, selectedNode, deviceMonitorTreeMap} = this.props;
    let {foldRootTree,showQuickSearch,showTypeFilter,expandedKeys,autoExpandParent,searchValue,selectedKeys} = this.state;
    const loop = data => data && data.map((item, i) => {
      const index = item.name.toLowerCase().indexOf(searchValue.toLowerCase());
      const beforeStr = item.name.substr(0, index);
      const searchStr = item.name.substr(index, searchValue.length);
      const afterStr = item.name.substr(index + searchValue.length);
      const title = index > -1 ? (
          <span style={{userSelect: 'none'}} title={item.name} onMouseDown={(e)=>this.onMouseDownTreeNode(e, item)}>{beforeStr}<span className="search-str">{searchStr}</span>{afterStr}{item.type == 'group' ? `(${item.children.length})` : ''}</span>
      ) : <span style={{userSelect: 'none'}} title={item.name} onMouseDown={(e)=>this.onMouseDownTreeNode(e, item)}>{item.name}{item.type == 'group' ? `(${item.children.length})` : ''}</span>;
      // const _icon = <img style={{marginBottom: '6px', marginRight: '5px'}} src={item.iconUrl} />;
      const _icon = ({ expanded }) => this.getTreeNodeIcon(item, expanded);
      if (item.children && item.children.length) {
        return (
          <TreeNode  icon={_icon} key={item.RecId} title={title} type={item.type} name={item.name}>
            {loop(item.children)}
          </TreeNode>
        );
      }
      return (<TreeNode icon={_icon} key={item.RecId} title={title} type={item.type} name={item.name}/>);
    });
    const menu = (
      <Menu className="right-menu">
        {Utils.hasPermission('group', 'add') ? <Menu.Item key="1" onClick={()=>this.onClickAddNewSubGroup(false, false)}><i className="iconfont icon-add right-menu-icon"></i> <span className="GroupMenuName">新增组</span></Menu.Item> : null}
        {Utils.hasPermission('group', 'sort') ? <Menu.Item key="2" onClick={()=>this.onClickSortGroup(1, true)}><i className="iconfont icon-desc right-menu-icon"></i> <span className="GroupMenuName">排序</span></Menu.Item> : null}
      </Menu>
    )
    const selectedNodeStatus = this.getNodeStatus(selectedNode);
    const menuDisable = selectedNodeStatus == 'disabled' ? true : false;
    const deleteGroupBtnDisabled = selectedNode && selectedNode.type === 'group' && selectedNode.children != 0;
    return (
      <div className="leftcon" style={{height: 'calc(100% - 40px)'}}>
        <div className='monitorTreeHeader'>
          <div>
            <label style={{margin:'0',padding:'10px 2px 10px 0', height: 40}}>
                <span style={{display: 'block', marginTop: '-10px', lineHeight: '40px', float: 'left', height: '40px'}}>
                  {/*<span onClick={this.onClickFoldRootTree} style={{display:'inline-block',padding:'0 2px 0 4px', cursor: 'pointer'}}>
                    <Icon style={{fontSize: 12}} type={foldRootTree ? "right" : "down"} />
                  </span>*/}
           { Utils.hasPermission('group', 'add') || Utils.hasPermission('group', 'sort') ?
                    <Dropdown overlay={menu} trigger={['contextMenu']} onOpenChange={this.contextMenuVisibleChange}>
                      <span style={{display:'inline-block', cursor: 'pointer', paddingLeft: 5}} onClick={()=>{this.onTreeRootClick({name:'IT资源树', id:'se'})}}>&nbsp;IT资源树</span>
                    </Dropdown> :
                    <span style={{display:'inline-block', cursor: 'pointer', paddingLeft: 5}} onClick={()=>{this.onTreeRootClick({name:'IT资源树', id:'se'})}}>&nbsp;IT资源树</span>
                  }
                </span>
                { Utils.hasPermission('tree', 'refresh') ?
                  <Popover overlayClassName="custom-popover" placement="top" content="刷新监测树">
                    <span className="addCircle" onClick={this.onClickRefreshTree}><i className="iconfont icon-refresh"></i></span>
                  </Popover>
                : null }
                <Popover overlayClassName="custom-popover" placement="top" content="全部收起">
                  <span className="addCircle" onClick={this._handleOnClickShrinkAll}><MinusSquareOutlined /></span>
                </Popover>
                <Popover overlayClassName="custom-popover" placement="top" content="全部展开">
                  <span className="addCircle" onClick={this._handleOnClickExpandAll}><PlusSquareOutlined /></span>
                </Popover>
                { Utils.hasPermission('tree', 'select') ?
                  <Popover overlayClassName="custom-popover" placement="top" content="快速检索">
                    <span className="addCircle" onClick={()=>{this.setState({showQuickSearch:!showQuickSearch})}}><SearchOutlined /></span>
                  </Popover>
                : null }
            </label>
          </div>
        </div>
        <div style={{height: '100%', position: 'relative'}}>
          <div style={{padding: '3px',display:showQuickSearch?'block':'none', height: '37px'}}>
            <Search style={{ width: '100%' }} placeholder="Search" onChange={this.searchTreeNodeByInputValue} />
          </div>
          <Spin wrapperClassName={"load-tree-spin" + (showQuickSearch ? ' tree-h' : '')} tip="加载中..." spinning={this.state.loadingTree}>
            <div id="customTreeListContainer" className="customTreeListContainer" style={{position: 'absolute', top: showQuickSearch?'0px':'0', right: '0', bottom: '0', left: '0' ,overflow:'auto'}}>
              <Tree
                showIcon
                showLine
                draggable
                onDrop={this.onDrop}
                onExpand={this.onExpand}
                expandedKeys={expandedKeys}
                autoExpandParent={autoExpandParent}
                onSelect={this.onTreeItemClick}
                onRightClick={this.onTreeItemRightClick}
                selectedKeys={selectedKeys}
              >
                {loop(showQuickSearch && searchValue ? this.state.filterTreeStore : this.props.treeStore)}
              </Tree>
            </div>
          </Spin>
        </div>

        <div className='zTreeMonitor' style={{position:'relative'}}>
          {/** 在子组上的右键菜单 */}
          <div id="rMenu3">
              <ul className="rightClickMenu" style={{"display":"none"}}>
                  { Utils.hasPermission('equipment', 'add') ? <li>
                      <a onClick={()=>this.handleCreateResourceModal(false)}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/add.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-add right-menu-icon"></i>
                          <span className="GroupMenuName">新增资源</span>
                      </a>
                  </li> : null }

                  { Utils.hasPermission('group', 'sort') || Utils.hasPermission('equipment', 'sort') ? <li>
                      <a onClick={() => this.onClickSortGroup(1)}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/refresh.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-desc right-menu-icon"></i>
                          <span className="GroupMenuName">排序</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('equipment', 'add') || Utils.hasPermission('group', 'sort') || Utils.hasPermission('equipment', 'sort') ? <hr /> : null }
                  { Utils.hasPermission('group', 'add') ? <li>
                      <a onClick={()=>this.onClickAddNewSubGroup(false, false)}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/addson.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-add right-menu-icon"></i>
                          <span className="GroupMenuName">新增分组</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('group', 'edit') ? <li>
                      <a onClick={()=>this.onClickAddNewSubGroup(true, false)}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/edit.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-edit right-menu-icon"></i>
                          <span className="GroupMenuName">编辑分组</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('group', 'delete') ? <li>
                      <a href="javascript:void(0)" onClick={this.deleteGroup} disabled={deleteGroupBtnDisabled}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/delete.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-delete right-menu-icon"></i>
                          <span className="GroupMenuName">删除分组</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('group', 'disable') ? <li id="monitorTree2Startli">
                      <a href="javascript:void(0)" onClick={this.openGroup} disabled={!menuDisable}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/start.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-enable right-menu-icon"></i>
                          <span className="GroupMenuName">启用分组</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('group', 'disable') ? <li id="monitorTree2Disableli">
                      <a href="javascript:void(0)" onClick={this.disableGroup} disabled={menuDisable}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/disable.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-disable right-menu-icon"></i>
                          <span className="GroupMenuName">禁用分组</span>
                      </a>
                  </li> : null }
              </ul>
          </div>

          {/** 点击在资源上的右键菜单 */}
          <div id="rMenu4" >
              <ul className="rightClickMenu" style={{"display":"none"}}>
                  { Utils.hasPermission('monitor', 'add') ? <li>
                      <a onClick={this.handleCreateMonitorModal}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/monitor.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-add right-menu-icon"></i>
                          <span className="GroupMenuName">新增监测器</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('monitor', 'sort') ? <li>
                      <a onClick={() => this.onClickSortGroup()}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/refresh.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-desc right-menu-icon"></i>
                          <span className="GroupMenuName">排序</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('monitor', 'add') || Utils.hasPermission('monitor', 'sort') ? <hr/> : null }
                  {/* 历史曲线入口暂时隐藏，恢复时去掉 false && 即可 */}
                  {false && Utils.hasPermission('equipment', 'historycurve') ? <li>
                      <a href="javascript:void(0)" onClick={this.openResourceDashboard}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/dashboard.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-dashboard right-menu-icon"></i>
                          <span className="GroupMenuName">历史曲线</span>
                      </a>
                  </li> : null }
                  {false && Utils.hasPermission('equipment', 'historycurve') ? <hr/> : null }
                  { Utils.hasPermission('equipment', 'edit') ? <li>
                      <a href="javascript:void(0)" onClick={()=>this.handleCreateResourceModal(true)}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/editzy.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-edit right-menu-icon"></i>
                          <span className="GroupMenuName">编辑资源</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('equipment', 'refresh') ? <li>
                      <a href="javascript:void(0)" onClick={this.refreshEquipment}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/refreshzy.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-refresh right-menu-icon"></i>
                          <span className="GroupMenuName">刷新资源</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('equipment', 'delete') ? <li>
                      <a href="javascript:void(0)" onClick={this.deleteEquipment}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/deletezy.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-delete right-menu-icon"></i>
                          <span className="GroupMenuName">删除资源</span>
                      </a>
                  </li> : null }
                  {/* zs  移动权限 */}
                  { Utils.hasPermission('equipment', 'delete') ? <li>
                      <a href="javascript:void(0)" onClick={()=>{
                      console.log(this.MoveEquipmentRef)
                      // 传入右键选中的设备节点，供弹窗默认选中其当前所在分组
                      this.MoveEquipmentRef.current.showModal(this.props.selectedNode)
                      }}>
                          <DragOutlined className="right-menu-icon" />
                          <span className="GroupMenuName">移动资源</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('equipment', 'disable') ? <li id="rightMenuStartEquipmentLi">
                      <a href="javascript:void(0)" onClick={this.startEquipment} disabled={!menuDisable}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/startzy.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-enable right-menu-icon"></i>
                          <span className="GroupMenuName">启用资源</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('equipment', 'disable') ? <li id="rightMenuDisableEquipmentLi">
                      <a href="javascript:void(0)" onClick={this.disableEquipment} disabled={menuDisable}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/disablezy.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-disable right-menu-icon"></i>
                          <span className="GroupMenuName">禁用资源</span>
                      </a>
                  </li> : null }
                  {/*<hr/>
                  <li id="rightMenuDisableEquipmentLi">
                      <a href="javascript:void(0)" onClick={this.connectRemoteDesk}>
                          <Icon className="right-menu-icon" type="desktop" />
                          <span className="GroupMenuName">远程连接</span>
                      </a>
                  </li>*/}
                  {/*<li>
                      <a href="javascript:void(0)">
                          <span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/copyzy.png') 0 0 no-repeat"}}></span>
                          <span className="GroupMenuName">移动资源</span>
                      </a>
                  </li>*/}
              </ul>
          </div>

          {/** 点击在监测器上的右键菜单 */}
          <div id="rMenu5" className="rMenu">
              <ul className="rightClickMenu" style={{"display":"none"}}>
                  { Utils.hasPermission('monitor', 'edit') ? <li>
                      <a href="javascript:void(0)" onClick={this.handleEditMonitor}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/editzy.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-edit right-menu-icon"></i>
                          <span className="GroupMenuName">编辑监测器</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('monitor', 'refresh') ? <li>
                      <a href="javascript:void(0)" onClick={this.refreshMonitor}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/refreshzy.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-refresh right-menu-icon"></i>
                          <span className="GroupMenuName">刷新监测器</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('monitor', 'delete') ? <li>
                      <a href="javascript:void(0)" onClick={this.deleteMonitor}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/deletezy.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-delete right-menu-icon"></i>
                          <span className="GroupMenuName">删除监测器</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('monitor', 'disable') ? <li id="rightMenuStartMonitorLi">
                      <a href="javascript:void(0)" onClick={this.startMonitor} disabled={!menuDisable}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/startzy.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-enable right-menu-icon"></i>
                          <span className="GroupMenuName">启用监测器</span>
                      </a>
                  </li> : null }
                  { Utils.hasPermission('monitor', 'disable') ? <li id="rightMenuDisableMonitorLi">
                      <a href="javascript:void(0)" onClick={this.disableMonitor} disabled={menuDisable}>
                          {/*<span className="GroupMenuIconSpan" style={{"background":"url('public/img/itoss/menuitem/disablezy.png') 0 0 no-repeat"}}></span>*/}
                          <i className="iconfont icon-disable right-menu-icon"></i>
                          <span className="GroupMenuName">禁用监测器</span>
                      </a>
                  </li> : null }
              </ul>
          </div>
        </div>
        {/* ref={(el)=>this.MoveEquipmentRef=el}  这种方式引用不需要加current*/}
        <MoveEquipment 
            ref={this.MoveEquipmentRef}
            // ref={(el)=>this.MoveEquipmentRef=el}
        />
      </div>
    );
  }

  openGroup = ()=>{ //启用分组
    const selectedNode = this.props.selectedNode;
    // this.props.deviceMonitorActions.changeGroupStatus(param, this.onRefreshTree);
    const association = this.props.deviceMonitorActions.getTreeNodeAssociation(selectedNode.pid, '');
    var param = {
      key: 'start',
      RecId: selectedNode.id,
      Status: 'good',
      GroupName: selectedNode.name,
      association: association
    };
    this.props.deviceMonitorActions.updateEccGroup(param, this.onRefreshTree);
    var rMenu = $("#rMenu3");
    if (rMenu) rMenu.css({"visibility": "hidden"});
  }
  disableGroup = ()=>{ //禁用分组
    let _this = this;
    confirm({
      title: '确定要禁用此子组吗?',
      content: '',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      maskClosable: true,
      onOk() {
        const selectedNode = _this.props.selectedNode;
        const association = _this.props.deviceMonitorActions.getTreeNodeAssociation(selectedNode.pid, '');
        var param = {
          key: 'disabled',
          RecId: selectedNode.id,
          Status: 'disabled',
          GroupName: selectedNode.name,
          association: association // 用于操作审计中关联属性
        };
        _this.props.deviceMonitorActions.updateEccGroup(param, _this.onRefreshTree);
      },
      onCancel() { },
    });
    var rMenu = $("#rMenu3");
    if (rMenu) rMenu.css({"visibility": "hidden"});
  }

  getDeletedGroupIds = (data, deletedData) => {
    if (data.length) {
      data.map((item) => {
        if (item.GroupEquipment) {
          deletedData.groupIds.push(item.RecId);
          this.getDeletedGroupIds(item.GroupEquipment, deletedData);
        } else if (item.EquipmentMonitor) {
          deletedData.equipmentIds.push(item.RecId);
          this.getDeletedGroupIds(item.EquipmentMonitor, deletedData);
        } else if (item.MonitorAlarm) {
          deletedData.monitorIds.push({monitorId: item.RecId, monitorType: item.MonitorType});
          this.getDeletedGroupIds(item.MonitorAlarm, deletedData);
        } else if (item.MonitorId) {
          deletedData.alarmIds.push(item.RecId);
        }
      })
    }
  }

  deleteGroup = ()=>{  //删除分组
    let _this = this;
    confirm({
      title: '确定要删除此子组吗?',
      content: '删除后将无法恢复',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      maskClosable: true,
      className: 'confirm-modal',
      onOk() {
        const selectedNode = _this.props.selectedNode;
        let cid = selectedNode.id;
        let pid = selectedNode.pid;
        const association = _this.props.deviceMonitorActions.getTreeNodeAssociation(pid, '');
        var deletedData = {groupIds: [ ], equipmentIds: [], monitorIds: [], alarmIds: [], RecId: cid, GroupName: selectedNode.name, association: association};
        _this.props.homeActions.setLoadingStatus(true);
        _this.props.equipmentActions.getCurrentGroupAllData(cid, (data) => {
          _this.getDeletedGroupIds(data, deletedData);
          // console.log('deleted ids--', deletedData);
          _this.props.deviceMonitorActions.deleteEccGroup(deletedData, ()=>{
            _this.props.homeActions.setLoadingStatus(false);
            let parentNode = _this.props.deviceMonitorTreeMap[pid];
            if(!parentNode) {
              parentNode = {name:'IT资源树', id:'se'};
            }
            // _this.props.equipmentActions.setSelectedNode(parentNode);
            // _this.props.equipmentActions.setBackupTreeNode(parentNode);
            _this.onRefreshTree(parentNode);
          });
        })
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
    var rMenu = $("#rMenu3");
    if (rMenu) rMenu.css({"visibility": "hidden"});
  }
  openResourceDashboard = () => {
    if (this.props.selectedNode.id !== this.props.backupTreeNode.id) {
      this.onClickMonitorTreeNode(this.props.selectedNode);
    }
    if (this.props.resourceViewActiveTab !== '2') {
      this.props.equipmentActions.setResourceViewActiveTab('2')
    }
    var rMenu = $("#rMenu4");
    if (rMenu) rMenu.css({"visibility": "hidden"});
  }
  startEquipment = ()=>{  //启用资源
    const selectedNode = this.props.selectedNode;
    const association = this.props.deviceMonitorActions.getTreeNodeAssociation(selectedNode.pid, '');
    var param = {
      key: 'start',
      RecId: selectedNode.id,
      EquipmentStatus: 'good',
      name: selectedNode.name,
      association: association
    };
    this.props.deviceMonitorActions.updateEquipment(param, this.onRefreshTree);
    var rMenu = $("#rMenu4");
    if (rMenu) rMenu.css({"visibility": "hidden"});
  }
  disableEquipment = ()=>{  //禁用资源
    let _this = this;
    confirm({
      title: '确定要禁用此资源吗?',
      content: '',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      maskClosable: true,
      onOk() {
        const selectedNode = _this.props.selectedNode;
        const association = _this.props.deviceMonitorActions.getTreeNodeAssociation(selectedNode.pid, '');
        var param = {
          key: 'disabled',
          RecId: selectedNode.id,
          EquipmentStatus: 'disabled',
          name: selectedNode.name,
          association: association // 用于操作审计中关联属性
        };
        _this.props.deviceMonitorActions.updateEquipment(param, _this.onRefreshTree);
      },
      onCancel() { },
    });
    var rMenu = $("#rMenu4");
    if (rMenu) rMenu.css({"visibility": "hidden"});
  }
  refreshEquipment = () => {//刷新资源
    // this.onTreeItemClick(null, {node: {props: {eventKey: this.props.selectedNode.id}}});
    let cid = this.props.selectedNode.id;
    var equipment = this.props.selectedNode;
    const auditData = {
      type: 'refresh_resource',
      // BoId: equipment.id,
      BoId: 'resource',
      desc: equipment.name,
      OperationAssociation: this.props.deviceMonitorActions.getTreeNodeAssociation(equipment.pid, '')
    }
    var monitors = equipment.EquipmentMonitor.filter(item => item.MonitorStatus !== 'disabled' && !item.IsDisabled);
    if (equipment.EquipmentStatus == 'disabled') {
      Utils.showMessageDialog("提示", "该资源不符合刷新规则", "warning");
      return;
    }
    let ids = monitors.map((item) => { return item.RecId; });
    if (ids.length > 0) {
      this.props.deviceMonitorTreeActions.openResourcePanel('refresh_resource');
      this.props.deviceMonitorActions.getThresholdList(ids, (data)=>{
        this.props.equipmentActions.refreshResourceMonitors(monitors, () => {
          setTimeout(() => {
            this.handleOnClickRefreshMonitorTree(()=>{
              this.onTreeItemClick(null, {node: {props: {eventKey: cid}}});
            });
          }, 10)
        }, null, auditData);
      });
    } else {
      Utils.showMessageDialog("提示", "该资源下没有可刷新监测器", "warning");
    }
    var rMenu = $("#rMenu4");
    if (rMenu) rMenu.css({"visibility": "hidden"});
  }
  deleteEquipment = ()=>{  //删除资源
    let _this = this;
    confirm({
      title: '确定要删除此资源吗?',
      content: '删除后将无法恢复',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      maskClosable: true,
      onOk() {
        const selectedNode = _this.props.selectedNode;
        let cid = selectedNode.id;
        let pid = selectedNode.pid;
        const association = _this.props.deviceMonitorActions.getTreeNodeAssociation(pid, '');
        // 新接口 /equipment/delete 自动级联删监测器/告警条件，无需先拉子树收集 id
        var deletedData = {equipmentIds: [ cid ], monitorIds: [], alarmIds: [], RecId: cid, name: selectedNode.name, association: association};
        _this.props.homeActions.setLoadingStatus(true);
        _this.props.deviceMonitorActions.deleteEquipment(deletedData, ()=>{
          _this.props.homeActions.setLoadingStatus(false);
          let parentNode = _this.props.deviceMonitorTreeMap[pid];
          _this.updateSubGroupView(parentNode, true);
          _this.onRefreshTree(parentNode);
        });
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
    var rMenu = $("#rMenu4");
    if (rMenu) rMenu.css({"visibility": "hidden"});
  }

  //产品授权点数验证
  productLicenseAuth = (callback) => {
    this.props.settingActions.getLicenseInfoData((licInfo)=>{
      if (licInfo) {
        let isOut = parseInt(licInfo.NETWORK_TOTAL_COUNT.split(" ")[1]) - parseInt(licInfo.NETWORK_USE_COUNT) <= 0 && parseInt(licInfo.SERVER_TOTAL_COUNT.split(" ")[1]) - parseInt(licInfo.SERVER_USE_COUNT) <= 0;
        if (isOut) {
          let tipText = `您购买的服务器与应用监测、网络设备监测授权点数已达最高点数${Utils.authenanceTip}`;
          Modal.info({
            title: '产品授权提示',
            content: (
              <div>{tipText}</div>
            ),
            onOk() {},
          });
        } else {
          callback && callback();
        }
      }
    });
  }


  handleCreateMonitorModal = ()=>{ //点击添加监视器
    var rMenu = $("#rMenu4");
    if (rMenu) rMenu.css({"visibility": "hidden"});
    //产品授权点数验证
    this.productLicenseAuth(()=>{
      this.props.deviceMonitorTreeActions.openResourcePanel('add_monitor');
    });
  }
  handleEditMonitor = ()=>{ //点击编辑监视器
    var rMenu = $("#rMenu5");
    if (rMenu) rMenu.css({"visibility": "hidden"});
    let {selectedNode, deviceMonitorTreeMap} = this.props;
    // const selectedResource = deviceMonitorTreeMap[selectedNode.EquipmentId];
    // this.props.equipmentActions.setSelectedResource(selectedResource);
    // this.props.equipmentActions.setMonitorsPropertyData(selectedNode);
    // this.props.equipmentActions.getMonitorsExtraPropertyDataFromID({monitorId: selectedNode.id, monitorType: selectedNode.MonitorType});
    // var _locale = [{monitorType: selectedNode.MonitorType, resourceType: selectedResource.eqType.replace('Equipment.', ''), key: selectedNode.MonitorName}];
    // this.props.equipmentActions.getMonitorLocale(_locale, (result)=> {
    //   this.props.equipmentActions.setSelectedMonitor({id:selectedNode.RecId, name:selectedNode.name, description: result ? result[selectedNode.MonitorType].Description : selectedNode.Description, returnValue:"", monitorType:selectedNode.MonitorType, monitorPackage:selectedNode.MonitorPackage});
    //   this.props.deviceMonitorTreeActions.openResourcePanel('edit_monitor');
    // })
    this.props.deviceMonitorActions.getThresholdList([selectedNode.id], (data)=>{
      // const selectedResource = this.props.deviceMonitorTreeMap[selectedNode.EquipmentId];
      // this.props.equipmentActions.setSelectedResource(selectedResource);
      this.props.equipmentActions.setSelectedClickNode(selectedNode);
      this.props.deviceMonitorActions.setMonitorView(5);
      this.props.equipmentActions.setMonitorDetailViewActiveTab('4');
    });
  }
  onClickFoldRootTree = ()=>{ //点击是否折叠or打开根节点。
    let {foldRootTree} = this.state;
    this.setState({foldRootTree:!foldRootTree});
    if(!foldRootTree){
      $('.customTreeListContainer').slideUp();
    }else{
      $('.customTreeListContainer').slideDown();
    }
  }

  checkRefreshMonitorView = () => {
    const {monitorView, backupResource, selectedNode, deviceMonitorTreeMap} = this.props;
    let _resource = null;
    if (selectedNode.type == 'monitor') {
      _resource = deviceMonitorTreeMap[selectedNode.EquipmentId];
    } else if (selectedNode.type == 'equipment') {
      _resource = selectedNode;
    }
    if (!_resource) {
      return;
    }
    if (monitorView == 4 && backupResource.id == _resource.id) {
      this.props.equipmentActions.setBackupResource(Object.assign({}, deviceMonitorTreeMap[backupResource.id]));
      let ids = this.props.backupResource.EquipmentMonitor.map((item) => { return item.RecId; });
      ids.length && this.props.deviceMonitorActions.getThresholdList(ids);
    } else if (monitorView == 5) {
      this.props.equipmentActions.setSelectedClickNode(Object.assign({}, deviceMonitorTreeMap[selectedNode.id]));
    }
  }

  refreshMonitor = () => { //刷新监测器
    let selectedNode = this.props.selectedNode;
    if (!this.props.selectedNode.IsDisabled && this.props.selectedNode.MonitorStatus != "disabled") {
      this.props.deviceMonitorTreeActions.openResourcePanel('refresh_resource');
      const auditData = {
        type: 'refresh_monitor',
        // BoId: selectedNode.id,
        BoId: 'monitor',
        desc: selectedNode.name,
        OperationAssociation: this.props.deviceMonitorActions.getTreeNodeAssociation(selectedNode.pid, '')
      }
      this.props.deviceMonitorActions.getThresholdList([selectedNode.id], (data)=>{
        this.props.equipmentActions.refreshResourceMonitors([ this.props.selectedNode ], () => {
          this.onRefreshTree(this.props.selectedNode);
        }, null, auditData);
      });
    } else {
      Utils.showMessageDialog("提示", "该监测器不符合刷新规则", "warning");
    }
    var rMenu = $("#rMenu5");
    if (rMenu) rMenu.css({"visibility": "hidden"});
  }

  deleteMonitor = ()=>{  //删除监测器
    let _this = this;
    confirm({
      title: '确定要删除此监测器吗?',
      content: '删除后将无法恢复',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      maskClosable: true,
      onOk() {
        const selectedNode = _this.props.selectedNode;
        let cid = selectedNode.id, pid = selectedNode.pid;
        const association = _this.props.deviceMonitorActions.getTreeNodeAssociation(pid, '');
        _this.props.homeActions.setLoadingStatus(true);
        _this.props.deviceMonitorActions.deleteMonitor({monitorId: cid, monitorType: selectedNode.MonitorType, name: selectedNode.name, association: association}, ()=>{
          _this.props.homeActions.setLoadingStatus(false);
          let parentNode = _this.props.deviceMonitorTreeMap[pid];
          // _this.props.equipmentActions.setSelectedNode(parentNode);
          _this.props.equipmentActions.setBackupResource(parentNode);
          _this.updateSubGroupView(parentNode, true);
          _this.onRefreshTree(parentNode);
        });
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
    var rMenu = $("#rMenu5");
    if (rMenu) rMenu.css({"visibility": "hidden"});
  }

  startMonitor = ()=>{  //启用监测器
    let selectedNode = this.props.selectedNode;
    var param = {
      key: 'start',
      RecId: selectedNode.id,
      IsDisabled: false,
      MonitorStatus: 'good',
      name: selectedNode.name,
      association: this.props.deviceMonitorActions.getTreeNodeAssociation(selectedNode.pid, '') // 用于操作审计中关联属性
    };
    this.props.homeActions.setLoadingStatus(true);
    this.props.deviceMonitorActions.updateMonitor(param, () => {
      this.props.homeActions.setLoadingStatus(false);
      this.onRefreshTree();
    });
    var rMenu = $("#rMenu5");
    if (rMenu) rMenu.css({"visibility": "hidden"});
  }

  disableMonitor = ()=>{  //禁用监测器
    let _this = this;
    confirm({
      title: '确定要禁用此监测器吗?',
      content: '',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      maskClosable: true,
      onOk() {
        let selectedNode = _this.props.selectedNode;
        var param = {
          key: 'disabled',
          RecId: selectedNode.RecId,
          IsDisabled: true,
          MonitorStatus: 'disabled',
          name: selectedNode.name,
          association: _this.props.deviceMonitorActions.getTreeNodeAssociation(selectedNode.pid, '') // 用于操作审计中关联属性
        };
        _this.props.homeActions.setLoadingStatus(true);
        _this.props.deviceMonitorActions.updateMonitor(param, () => {
          _this.props.homeActions.setLoadingStatus(false);
          _this.onRefreshTree();
        });
      },
      onCancel() { },
    });
    var rMenu = $("#rMenu5");
    if (rMenu) rMenu.css({"visibility": "hidden"});
  }

  connectRemoteDesk = () => { // 连接远程桌面

  }
}

// export default MonitorTreeComp;
const mapStateToProps = (state) => {
  let { deviceMonitorTreeData, deviceMonitorTreeMap, treeStore, resourcePanelShow} = state.deviceMonitorTreeReducer;
  const { pieChartMonitorType,monitorTreeComp, monitorView,
      childrenGroup,childrenEquip,selectedDeivceGroup,noRefreshMonitorViewFlag, resourceViewType } = state.deviceMonitorReducer
  const { createResourcesTableData, createMonitorsTableData,
    resourceTypes, selectedNode,selectedNodeId,
    commonMonitors, navigateFromCreateMonitorViewFlag,
    equipmentModel, getResourcesPropertyDataFromID,
    resourcesData, resourcesPropertyData, backupTreeNode,

    monitorErrorAlarmText, monitorWarningAlarmText, monitorGoodAlarmText, monitorErrorConditionsData, monitorWarningConditionsData,
    monitorGoodConditionsData, equipmentServerAddress, monitorsPropertyData, monitorsPropertyEdit, backupResource, monitorAlarmConditionNameData,
    monitorSettingErrorConditionsData, monitorSettingWarningConditionsData, monitorSettingGoodConditionsData, selectedMonitorIPMISensorCounter, monitorIPMISensorCounters, selectedMonitor,
    refreshResourceMonitors, resourceViewActiveTab, draggedNode} = state.equipmentReducer;
  // let {windowSizeChange} = state.homeReducer;
  const { networkNodes, b2DMode, bAddedDraggedNodeIn3D } = state.threeDPerspectiveDiagramReducer
  return {
    deviceMonitorTreeData, deviceMonitorTreeMap, treeStore, resourcePanelShow, selectedDeivceGroup,
    pieChartMonitorType,monitorTreeComp, monitorView,
    childrenGroup,childrenEquip,
    createResourcesTableData, createMonitorsTableData,
    resourceTypes, selectedNode,selectedNodeId,
    commonMonitors, navigateFromCreateMonitorViewFlag,
    equipmentModel, getResourcesPropertyDataFromID,
    resourcesData, resourcesPropertyData, backupTreeNode,

    monitorErrorAlarmText, monitorWarningAlarmText, monitorGoodAlarmText, monitorErrorConditionsData, monitorWarningConditionsData,
    monitorGoodConditionsData, equipmentServerAddress, monitorsPropertyData, monitorsPropertyEdit, backupResource, monitorAlarmConditionNameData,
    monitorSettingErrorConditionsData, monitorSettingWarningConditionsData, monitorSettingGoodConditionsData, selectedMonitorIPMISensorCounter, monitorIPMISensorCounters, selectedMonitor,
    refreshResourceMonitors, resourceViewActiveTab, noRefreshMonitorViewFlag, draggedNode,
    networkNodes, resourceViewType, b2DMode, bAddedDraggedNodeIn3D
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    homeActions: bindActionCreators(homeActions, dispatch),
    deviceMonitorTreeActions:bindActionCreators(deviceMonitorTreeActions,dispatch),
    deviceMonitorActions:bindActionCreators(deviceMonitorActions,dispatch),
    equipmentActions:bindActionCreators(equipmentActions,dispatch),
    settingActions: bindActionCreators(settingActions, dispatch),
    threeDPerspectiveDiagramActions:bindActionCreators(threeDPerspectiveDiagramActions,dispatch),
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(MonitorTreeComp)
